import Dashboard from "@/components/dashboard/dashboard";
import DashboardPlaceholder from "@/components/dashboard/dashboard-placeholder";
import { SyncProgressProvider } from "@/components/dashboard/sync-progress";
import { Layout } from "@/components/layout";
import { requireAuth } from "@/lib/auth/auth-guard";
import { ensureProfile } from "@/lib/loaders/utils";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: (ctx) => requireAuth(ctx.context, ctx.location),
  loader: async ({ context }) => {
    // Ensure user has profile (but allow dashboard to handle missing provider links)
    await ensureProfile(context.auth.getToken);
    // Comment out ensureProviderLinks to prevent automatic redirect
    // await ensureProviderLinks(context.auth.getToken);
    return null;
  },
  component: DashboardPage,
});

function DashboardPage() {
  return (
    <SyncProgressProvider>
      <Layout title="Dashboard" suspenseFallback={<DashboardPlaceholder />}>
        <Dashboard />
      </Layout>
    </SyncProgressProvider>
  );
}
